export default __webpack_public_path__ + "static/media/JeanPhoto.b6fb1dcd.png";